/**
 * Timesheet enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Time entry source labels
export const timeEntrySourceLabels = {
    manual: 'Manual',
    auto: 'Automatic',
};
export const timeEntrySourceValues = Object.keys(timeEntrySourceLabels);
// Time entry status labels
export const timeEntryStatusLabels = {
    open: 'Clocked In',
    completed: 'Completed',
    approved: 'Approved',
};
export const timeEntryStatusValues = Object.keys(timeEntryStatusLabels);
//# sourceMappingURL=timesheets.js.map